module.exports = __webpack_public_path__ + "img/bg-chat.36262062.png";